module.exports = __webpack_public_path__ + "static/media/INZ1163.bbc9ba17.pdf";